// Hook: GET /api/clients/:id → prototype Client + matters shape, with
// fixture fallback for prototype client IDs that don't resolve as Mongo
// ObjectIds.

import { useQuery } from "@tanstack/react-query";
import { fetchClient, type ClientWithMatters } from "../api/mock";

export function useClient(clientId: string | undefined) {
  return useQuery<ClientWithMatters | null>({
    queryKey: ["client", clientId ?? ""],
    queryFn: () => (clientId ? fetchClient(clientId) : Promise.resolve(null)),
    enabled: !!clientId,
  });
}
